import { Icons, ChakraButton as Button } from "@airhelp/react-ui-components";
import { arrowColor } from "../utility/styleConsts";
import type { PrevButtonProps } from "./PrevButton.d";

const PrevButton = ({ previousPage, canPreviousPage }: PrevButtonProps) => (
  <Button
    aria-label="previous"
    variant="unstyled"
    onClick={previousPage}
    isDisabled={!canPreviousPage}
    color={arrowColor(canPreviousPage)}
    display="flex"
    alignItems="center"
    minWidth={{ base: 8, md: 10 }}
    minHeight={{ base: 8, md: 10 }}
    sx={{ svg: { boxSize: { base: 4, md: 5 } } }}
  >
    <Icons.ArrowLeft />
  </Button>
);

export default PrevButton;
